/* Terraloo Sleek — header dropdown + mobile submenu */
(function () {
  'use strict';

  document.querySelectorAll('[data-tls-nav-item]').forEach(function (item) {
    var toggle = item.querySelector('[data-tls-nav-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('[data-tls-nav-item].is-open').forEach(function (o) {
        o.classList.remove('is-open');
        var t = o.querySelector('[data-tls-nav-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-tls-nav-item]')) {
      document.querySelectorAll('[data-tls-nav-item].is-open').forEach(function (o) {
        o.classList.remove('is-open');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-tls-nav-item].is-open').forEach(function (o) {
        o.classList.remove('is-open');
      });
    }
  });

  document.querySelectorAll('[data-tls-mobile-nav-item]').forEach(function (item) {
    var toggle = item.querySelector('[data-tls-mobile-nav-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });
})();
